import { sessionManager } from './sessionManager';

/**
 * Returns CRUD permission flags for the given screen name.
 * Handles two API response formats:
 *   - string array: ['Dashboard', 'Customers', ...]
 *   - object array: [{screen_name, can_view, can_create, can_edit, can_delete}, ...]
 * Admins always receive full access.
 */
export function getPermissions(screenName) {
  const user = sessionManager.getUser();

  if (!user) {
    return { canView: false, canCreate: false, canEdit: false, canDelete: false };
  }

  if (user.role === 'admin') {
    return { canView: true, canCreate: true, canEdit: true, canDelete: true, advancedAccess: false, fromDate: null, toDate: null, includeNullDate: false };
  }

  const access = user.screen_access || [];

  // String array format — screen presence implies full CRUD
  if (access.length === 0 || typeof access[0] === 'string') {
    const has = access.includes(screenName);
    return { canView: has, canCreate: has, canEdit: has, canDelete: has, advancedAccess: false, fromDate: null, toDate: null, includeNullDate: false };
  }

  // Object array format with granular flags
  const screen = access.find((s) => s.screen_name === screenName);
  if (!screen) {
    return { canView: false, canCreate: false, canEdit: false, canDelete: false };
  }

  return {
    canView:   !!+screen.can_view,
    canCreate: !!+screen.can_create,
    canEdit:   !!+screen.can_edit,
    canDelete: !!+screen.can_delete,
    advancedAccess: !!+screen.advanced_access,
    fromDate: screen.from_date || null,
    toDate: screen.to_date || null,
    includeNullDate: !!+screen.include_null_date,
  };
}

/** Returns true if the screen is accessible at all (can_view or included in list). */
export function canAccessScreen(screenName) {
  return getPermissions(screenName).canView;
}